import React, { createContext } from 'react';

const FocusBaseContext = createContext({});
const MarkupContext = createContext({});
const MarkupListContext = createContext({});

export { FocusBaseContext, MarkupContext, MarkupListContext };
